import { type as typeUtil } from '@mews/framework';

export function Device({ id = '', name = '', ordering = 0 } = {}) {
    return typeUtil.create(Device, {
        id,
        name,
        ordering,
    });
}
